import React from "react";
import { Box, Container, Tab, Tabs } from "@mui/material";
import { C, CONTAINER, FONT } from "../accountStyles";


export default function AccountNavigation({ items, value, onChange }) {
  return (
    <Box sx={{ borderBottom: `1px solid ${C.lineStrong}`, bgcolor: C.paper }}>
      <Container maxWidth={CONTAINER} disableGutters sx={{ px: { xs: 0, sm: 3 } }}>
        <Tabs
          value={items.some((item) => item.key === value) ? value : false}
          onChange={(e, newValue) => onChange(newValue)}
          variant="fullWidth"
          aria-label="Account sections"
          sx={{
            minHeight: 56,
            maxWidth: { sm: 520 },
            "& .MuiTabs-indicator": { backgroundColor: C.ink, height: 2 },
            "& .MuiTab-root": {
              minHeight: 56,
              px: { xs: 1, sm: 2 },
              color: C.secondary,
              fontFamily: FONT,
              fontSize: { xs: "0.72rem", sm: "0.78rem" },
              fontWeight: 700,
              letterSpacing: { xs: "1.5px", sm: "2px" },
              textTransform: "uppercase",
              "&:hover": { color: C.ink },
              "&.Mui-focusVisible": { outline: `2px solid ${C.ink}`, outlineOffset: -2 },
            },
            "& .Mui-selected": { color: `${C.ink} !important` },
          }}
        >
          {items.map((item) => (
            <Tab
              key={item.key}
              value={item.key}
              label={item.label}
              id={`account-tab-${item.key}`}
              aria-controls={value === item.key ? `account-panel-${item.key}` : undefined}
              disableRipple
            />
          ))}
        </Tabs>
      </Container>
    </Box>
  );
}
